import React from 'react';
import env from 'env';
import { Table } from 'components/table/tableServerSide';
import { usePost } from 'components';
import { SiteLink } from 'components';
import { Loading, ErrorPopup } from 'components';
//import { Button, ErrorMessage } from 'components';

export function JoinList(props) {
    const columns = React.useMemo(
        () => [
            {
                Header: 'First Name',
                accessor: 'firstName',
                Cell: (c) => {
                    //console.log(c)
                    return (<SiteLink to={`/admin/join-reg/${c.row.original.joinRegistrationId}`}><b>{c.cell.value}</b></SiteLink>)
                }
            },
            {
                Header: 'Last Name',
                accessor: 'lastName',
            },
            {
                Header: 'Site',
                accessor: 'siteCode',
            },
            {
                Header: 'Country',
                accessor: 'country',
            },
            {
                Header: 'Email',
                accessor: 'email',
            },
            {
                Header: 'Postcode',
                accessor: 'postcode',
            },
            {
                Header: 'Registered Date',
                accessor: 'dateRegistered'
            }
        ],
        []
    )

    const [data, setData] = React.useState([]);
    const [loading] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const [totalCount, setTotalCount] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(30);
    const [pageIndex, setPageIndex] = React.useState(0);
    const [sortBy, setSortBy] = React.useState([]);

    const [filterWM, setFilterWM] = React.useState('all');
    const [filterCountry, setFilterCountry] = React.useState('W');
    const [filterKeyword, setFilterKeyword] = React.useState('');
    const [filterFrom, setFilterFrom] = React.useState('');
    const [filterTo, setFilterTo] = React.useState('');
    const post = usePost();

    React.useEffect(() => {
        //console.log('post.send', pageSize, pageIndex)
        post.send(env.apiBase + '/api/joinadmin/getregistrations', getSearchParam());
        // eslint-disable-next-line
    }, [filterWM, filterKeyword, filterCountry, filterFrom, sortBy, filterTo, pageSize, pageIndex]);

    React.useEffect(() => {
        if (post.done()) {
            //console.log('post.done', pageSize, pageIndex)
            const result = post.response;
            setPageCount(Math.ceil(result.totalCnt / pageSize))
            setTotalCount(result.totalCnt)
            setData(result.items);
        }
    }, [post, pageSize]);

    const fetchData = React.useCallback(({ pageSize, pageIndex, sortBy }) => {
        console.log('usecallback', pageSize, pageIndex, sortBy)
        setPageSize(pageSize);
        setPageIndex(pageIndex);
        setSortBy(sortBy);
    }, []);

    function getSearchParam() {
        return {
            pageSize: pageSize, pageNo: pageIndex + 1,
            keyword: filterKeyword,
            menOrWomen: filterWM,
            country: filterCountry,
            dateFrom: filterFrom,
            dateTo: filterTo,
            sortBy: sortBy
        }
    };

    if (post.loading()) {
        return <Loading />
    } else if (post.hasErrors()) {
        return <ErrorPopup title="Loading Error" errors={post.errors} />
    }

    // const changeFilterWM = (e) => {
    //     setFilterWM(e.target.value)
    //     window.localStorage.setItem('warranty.filterWM', e.target.value);
    // }

    const changeFilterCountry = (e) => {
        setFilterCountry(e.target.value)
        window.localStorage.setItem('warranty.filterCountry', e.target.value);
    }

    const changeFilterFrom = (e) => {
        setFilterFrom(e.target.value)
        window.localStorage.setItem('warranty.filterFrom', e.target.value);
    }
    const changeFilterTo = (e) => {
        setFilterTo(e.target.value)
        window.localStorage.setItem('warranty.filterTo', e.target.value);
    }

    function handleKeyPress(e) {
        if (e.key === 'Enter') {
            setFilterKeyword(e.target.value)
            //window.localStorage.setItem('warranty.filterKeyword', e.target.value);
        }
    };

    function removeFilter() {
        setFilterWM('');
        setFilterCountry('');
        setFilterKeyword('');
        setFilterFrom('');
        setFilterTo('');
    }

    return (
        <>
            <h1>Join Registrations</h1>
            <div className="filter" style={{ minHeight: '30px' }}>
                <div style={{ float: 'left', display: 'flex', alignItems: 'center' }}>

                    {/* <select name="wm" type="select" className="form-control" value={filterWM} onChange={changeFilterWM} style={{ marginRight: '10px' }}>
                        <option value="all">All Sites</option>
                        <option value="W">Women</option>
                        <option value="M">Men</option>
                    </select> */}

                    <select name="country" type="select" className="form-control" value={filterCountry} onChange={changeFilterCountry} style={{ marginRight: '10px' }}>
                        <option value="all">All Countries</option>
                        <option value="AU">AU</option>
                        <option value="NZ">NZ</option>
                    </select>
                    <input className="form-control" type="text" placeholder="Search" defaultValue={filterKeyword} onKeyPress={handleKeyPress} />
                    <span style={{ display: 'inlne-block', fontSize: '0.8rem', color: 'chocolate', marginLeft: '10px', cursor: 'pointer' }} onClick={removeFilter}>Reset filter</span>


                </div>
                <div style={{ float: 'right', display: 'flex', alignItems: 'center' }}><span style={{ marginRight: '5px' }}>Date Registered: </span>
                    <input className="form-control" type="date" value={filterFrom} onChange={changeFilterFrom} /> <span style={{ margin: "0 0.5rem" }}>-</span>
                    <input className="form-control" type="date" value={filterTo} onChange={changeFilterTo} style={{ marginRight: '0px' }} />
                </div>

            </div>

            <Table columns={columns}
                data={data}
                fetchData={fetchData}
                loading={loading}
                pageCount={pageCount}
                pageSize={pageSize}
                pageIndex={pageIndex}
                sortBy={sortBy}
                totalCount={totalCount} />

            <div style={{ marginTop: '2rem' }}></div>
        </>
    )


}